// Platform detection utilities

export const isStandalone = () => {
  const mq = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
  const ios = (window.navigator as any).standalone === true;
  return mq || ios;
};

export const isMobile = () => /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

export const getPlatform = () => {
  const ua = navigator.userAgent;
  return {
    isIOS: /iPhone|iPad|iPod/i.test(ua),
    isAndroid: /Android/i.test(ua),
    isChrome: /Chrome/i.test(ua) && !/Edg/i.test(ua),
    isSafari: /^((?!chrome|android).)*safari/i.test(ua),
  };
};

export const vibrate = (ms = 10) => navigator.vibrate?.(ms);

export const openMail = (to: string, subject: string, body: string) => {
  vibrate(10);
  const url = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = url;
};
